export default "__VITE_PUBLIC_ASSET__003d6b8c__"